<template>
  <app-layout :heading="$t('heading')">
    <v-card>
      <v-card-text>
        <v-text-field
          ref="referralLink"
          :loading="referralLink"
          :value="referralLink"
          :label="$t('linkHint')"
          append-outer-icon="file_copy"
          flat
          hide-details
          readonly
          @click="copy"
        />
      </v-card-text>
    </v-card>

    <v-card class="my-3">
      <v-card-text class="pa-0">
        <v-data-table
          :headers="headers"
          :items="referrals"
          :loding="isLoading"
          :pagination.sync="pagination"
          :total-items="paginationTotal"
          :rows-per-page-items="[15]"
        >

          <template
            slot="items"
            slot-scope="props"
          >

            <td>{{ props.item.id }}</td>
            <td>{{ props.item.user.email }}</td>
            <td>{{ props.item.user.first_name }} {{ props.item.user.last_name }}</td>
            <td class="text-xs-right">{{ $moment(props.item.created_at).format('DD.MM.YYYY') }}</td>

          </template>

          <template slot="no-data">
            <div class="font-italic text-xs-center">
              {{ $t('noRefs') }}
            </div>
          </template>

        </v-data-table>
      </v-card-text>
    </v-card>
  </app-layout>

</template>

<script>
import AffiliateApi from '@/api/AffiliateApi'
import PaginationApi from '@/api/PaginationApi'

import copyToClipboard from '@/utils/copyToClipboard'

export default {
  name: 'Referrals',
  data () {
    return {
      url: 'affiliate/referrals',
      isLoading: false,
      referralLink: '',
      referrals: [],
      pagination: {},
      paginationTotal: null,
      headers: [
        { text: this.$t('refId'), align: 'left', sortable: false },
        { text: this.$t('email'), align: 'left', sortable: false },
        { text: this.$t('name'), align: 'left', sortable: false },
        { text: this.$t('createdAt'), align: 'right', sortable: false }
      ]
    }
  },
  methods: {
    copy () {
      this.$notification({
        success: {
          message: copyToClipboard(this.referralLink) ? [this.$t('copiedToClipboard')] : null
        }
      })
    },
    async getPaginatedData () {
      this.isLoading = true
      try {
        const response = await PaginationApi.getPaginatedData(this.url, undefined, this.pagination.page)
        this.paginationTotal = response.total
        this.referrals = response.data
      } catch (e) {
        this.$notification(e)
      }
      this.isLoading = false
    }
  },
  watch: {
    pagination: {
      handler: `getPaginatedData`
    }
  },
  i18n: {
    messages: {
      en: {
        copiedToClipboard: 'Copied to clipboard',
        createdAt: 'Date',
        email: 'Email',
        heading: 'Referrals',
        headingAllReferrals: 'All your referrals',
        link: 'Referral link',
        linkHint: 'Copy this link and send it to friends or colleague',
        name: 'Name',
        noRefs: 'You have not recruited any members yet',
        refId: 'Referrals ID',
        status: 'Payment status'
      },
      tr: {
        copiedToClipboard: 'Panoya kopyalandı',
        createdAt: 'Tarih',
        email: 'E-posta',
        heading: 'Yönlendirmeler',
        headingAllReferrals: 'Tüm yönlendirmeleriniz',
        link: 'Yönlendirme adresi',
        linkHint: 'Bu adresi kopyalayın ve arkadaşlarınız ya da iş arkadaşlarınıza gönderin',
        name: 'İsim',
        noRefs: 'Henüz hiçbir üyeyi işe almadınız',
        refId: 'Yönlendirme IDsi',
        status: 'Ödeme Durumu'
      },
      de: {
        copiedToClipboard: 'In Zwischenablage kopiert',
        createdAt: 'Geworben am',
        email: 'E-Mail',
        heading: 'Partnerprogramm',
        headingAllReferrals: 'Ihre bisher geworbenen Mitglieder',
        link: 'Werbelink',
        linkHint: 'Kopieren Sie diesen Werbelink und geben Sie ihn Freunden und Bekannten',
        name: 'Name',
        noRefs: 'Bisher haben Sie noch keine Mitglieder geworben',
        refId: 'Partner ID',
        status: 'Bezahlstatus'
      },
      ru: {
        copiedToClipboard: 'Скопировано в буфер обмена',
        createdAt: 'Дата',
        email: 'Эл. адрес',
        heading: 'Рефералы',
        headingAllReferrals: 'Все ваши рефералы',
        link: 'Реферальная ссылка',
        linkHint: 'Скопируйте эту ссылку и отправьте ее друзьям или коллегам',
        name: 'Имя',
        noRefs: 'Вы еще не пригласили участников',
        refId: 'ID рефералов',
        status: 'Статус платежа'
      }
    }
  },
  async created () {
    try {
      const response = await AffiliateApi.getLink()
      this.referralLink = response.link
    } catch (e) {
      this.$notification(e)
    }
  }
}
</script>

<style scoped>
  /* TODO: Remove hack with icon position */
  >>> .v-input__icon--append-outer {
    margin-top: -.5em;
  }
</style>
